"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChatbotClient_endpoint, _ChatbotClient_eventHandler;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotClient = void 0;
const fetch_event_source_1 = require("@microsoft/fetch-event-source");
class ChatbotClient {
    constructor({ endpoint, eventHandler }) {
        _ChatbotClient_endpoint.set(this, void 0);
        _ChatbotClient_eventHandler.set(this, void 0);
        __classPrivateFieldSet(this, _ChatbotClient_endpoint, endpoint, "f");
        __classPrivateFieldSet(this, _ChatbotClient_eventHandler, eventHandler, "f");
    }
    prompt(promptToVideoInput, headers = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, fetch_event_source_1.fetchEventSource)(__classPrivateFieldGet(this, _ChatbotClient_endpoint, "f"), {
                method: "POST",
                body: JSON.stringify(promptToVideoInput),
                headers: Object.assign(Object.assign({}, headers), { "Content-Type": "application/json", "Accept": "text/event-stream" }),
                openWhenHidden: true,
                onopen: (res) => __awaiter(this, void 0, void 0, function* () {
                    if (res.ok && res.status === 200) {
                        // console.log("Connection made ", res);
                    }
                    else if (res.status >= 400 && res.status < 500 && res.status !== 429) {
                        // console.log("Client side error ", res);
                    }
                }),
                onmessage: (event) => {
                    const parsedData = JSON.parse(event.data);
                    __classPrivateFieldGet(this, _ChatbotClient_eventHandler, "f").call(this, parsedData);
                },
                onclose() {
                    // console.log("Connection closed by the server");
                },
                onerror(err) {
                    // console.log("There was an error from server", err);
                }
            });
        });
    }
}
exports.ChatbotClient = ChatbotClient;
_ChatbotClient_endpoint = new WeakMap(), _ChatbotClient_eventHandler = new WeakMap();
//# sourceMappingURL=chatbotClient.js.map